import React from 'react';

const Header = () => {
    return (
        <header >
            <h2 className="text-center">Consulta de Folios Suspendidos</h2>
        </header>
    );
};

export default Header;
